<template>
  <div class="trash-table">
    <div class="schedule-message">
      <h3 class="black bg-ghost-gray phm-mu mtl mbm">
        Holiday collection schedule
      </h3>
      <ul>
        <li><strong>Delays after a City-observed holiday:</strong> Trash and recycling collection will be delayed by one day for the rest of the week. If the holiday falls on a Friday, collection will take place on Saturday.</li>
        <li><strong>Areas with twice a week trash collection:</strong> These areas will have only one collection day during a holiday week. Trash will be picked up on the same day as your recycling.</li>
      </ul>
      <h4>Exceptions</h4>
      <ul>
        <li><strong>Weekend holiday:</strong> Holidays that occur on the weekend won't affect collection the following week.</li>
        <li><strong>Two holidays in one week:</strong> When there are two City-observed holidays in the same week, collections may be delayed by more than one day or follow a modified schedule.</li>
      </ul>
      <h4>List of City-observed holidays </h4>
    </div>
    <div class="holiday-list">
      <ul>
        <li
          v-for="holiday in upcomingHolidays"
          :key="holiday.holiday_label"
        >
          {{ holiday['Holiday observed'] }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TrashTable',
  props: {
    holidays: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data: function() {
    return {
      categoryList: [],
      viewMessage: false,
      searchTerm: null,
    };
  },
  computed: {
    upcomingHolidays() {
      let tempHolidays = this.holidays;
      return tempHolidays.sort((a, b) => {
        return new Date(a.start_date) - new Date(b.start_date);
      });
    },
  },
};
</script>